import { render, staticRenderFns } from "./UsersPrivilegeServicesReservationAddedServices.vue?vue&type=template&id=5c8bb0c4&scoped=true&"
import script from "./UsersPrivilegeServicesReservationAddedServices.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServicesReservationAddedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bb0c4",
  null
  
)

export default component.exports